import { Duration } from './Duration.esm.js';

var AlertStatus = /* @__PURE__ */ ((AlertStatus2) => {
  AlertStatus2["Snoozed"] = "snoozed";
  AlertStatus2["Accepted"] = "accepted";
  AlertStatus2["Dismissed"] = "dismissed";
  return AlertStatus2;
})(AlertStatus || {});
var AlertDismissReason = /* @__PURE__ */ ((AlertDismissReason2) => {
  AlertDismissReason2["Other"] = "other";
  AlertDismissReason2["Resolved"] = "resolved";
  AlertDismissReason2["Expected"] = "expected";
  AlertDismissReason2["Seasonal"] = "seasonal";
  AlertDismissReason2["Migration"] = "migration";
  AlertDismissReason2["NotApplicable"] = "not-applicable";
  return AlertDismissReason2;
})(AlertDismissReason || {});
const AlertDismissOptions = [
  {
    reason: "resolved" /* Resolved */,
    label: "This action item is now resolved."
  },
  {
    reason: "seasonal" /* Seasonal */,
    label: "This is an expected increase at this time of year."
  },
  {
    reason: "migration" /* Migration */,
    label: "This increase is from a migration in process."
  },
  {
    reason: "expected" /* Expected */,
    label: "This is an expected increase due to our team\u2019s priorities."
  },
  {
    reason: "not-applicable" /* NotApplicable */,
    label: "This action item doesn\u2019t make sense for my team."
  },
  {
    reason: "other" /* Other */,
    label: "Other (please specify)"
  }
];
const AlertSnoozeOptions = [
  {
    duration: Duration.P7D,
    label: "1 Week"
  },
  {
    duration: Duration.P30D,
    label: "1 Month"
  },
  {
    duration: Duration.P90D,
    label: "1 Quarter"
  }
];
var DataKey = /* @__PURE__ */ ((DataKey2) => {
  DataKey2["Previous"] = "previous";
  DataKey2["Current"] = "current";
  DataKey2["Name"] = "name";
  return DataKey2;
})(DataKey || {});

export { AlertDismissOptions, AlertDismissReason, AlertSnoozeOptions, AlertStatus, DataKey };
//# sourceMappingURL=Alert.esm.js.map
